import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getDependenciasEmpleador } from "../../../redux/actions/empleador";
import { StyledNte } from "../../styled/Prevencion";
import FormikAutocomplete from "../formik/FormikAutocomplete";

const initialValues = {
  establecimiento: "",
  soloActivos: false,
};

const validationSchema = Yup.object().shape({
  establecimiento: Yup.string().required("Campo Obligatorio").nullable(),
});

const SearchEstablecimiento = ({
  options,
  handleSearch,
  searchModel,
  setSelectedValue,
  searched,
  setOpenConfirmDialog,
  setEstablecimiento,
  setChecked,
  disabled,
  incluirObrasMayorAnio = false,
}) => {

  const dispatch = useDispatch();
  const hasDatosPost = useSelector((state) =>
    state.nte.postNte.decretoForm?.id ? true : false
  );
  const handleClearAutocomplete = () => {
    setSelectedValue("");
    handleSearch({ establecimiento: null });
  };

  return (
    <div>
      <Formik
        initialValues={{ ...initialValues, ...searchModel }}
        onSubmit={handleSearch}
        enableReinitialize={true}
        validationSchema={validationSchema}
      >
        {({ values }) => (

          <StyledNte.FormContainer>
            <StyledNte.InputContainer>
              <FormikAutocomplete
                name="establecimiento"
                variant="standard"
                options={options}
                renderOption={(option) => (option.nombre ? option.nombre : "")}
                filterOptions={(option) => (option.nombre ? option.nombre : "")}
                getOptions={() => dispatch(getDependenciasEmpleador(values.soloActivos, incluirObrasMayorAnio))}
                callBack={(values) => {
                  if (setEstablecimiento) {
                    setEstablecimiento(values);
                  }
                  if (searched && hasDatosPost) {
                    setOpenConfirmDialog(true);
                    setSelectedValue(values?.id);
                  } else if (!hasDatosPost && values) {
                    setSelectedValue(values?.id);
                    handleSearch({ establecimiento: values?.id });
                  } else {
                    setSelectedValue("");
                    handleSearch({ establecimiento: null });
                  }
                }}
                handleOnClear={handleClearAutocomplete}
                disabled={disabled}
              />
            </StyledNte.InputContainer>
            <StyledNte.ButtonContainer>
              <StyledNte.Checkbox
                name="soloActivos"
                label="Mostrar sólo establecimientos activos"
                callBack={() => {
                  dispatch(getDependenciasEmpleador(values.soloActivos, incluirObrasMayorAnio))
                  setChecked(values.soloActivos);
                }}
              />
            </StyledNte.ButtonContainer>
          </StyledNte.FormContainer>
        )}
      </Formik>

    </div>
  );
};

export default SearchEstablecimiento;
